import { backendInstance } from './axios';
export const getAllCurrencies = async () => {
    const response = await backendInstance.get('currency/currencies');
    return response.data;
};
